import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class UserAuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request || !(request as any).headers) {
      return next.handle(request);
    }

    const token = localStorage.getItem('token');

    const authRequest = token
      ? request.clone({
          setHeaders: {
            Authorization: token
          }
        })
      : request;

    return next.handle(authRequest);
  }
}
